import React from 'react'
import styled from 'styled-components'

import Link from './Link'
import {getCurrentLocale, languages} from '../../i18n'
import storage from '../../utils/storage'

const Container = styled.div`
  margin-left: 20px;
  display: flex;
  align-items: center;
`

const LanguageLink = styled(Link)`
  color: ${({active}) => (active ? '#ffa920' : '#002f5e')};
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 0;
  align-self: stretch;
  position: relative;
  transition: color 0.25s;
  font-family: 'basier_circle', sans-serif;

  &:hover {
    color: #ffa920;
  }
  :not(:last-child) {
    &::after {
      content: '/';
      margin: 0 10px;
      color: #002f5e;
    }
  }
`

const LanguageSwitch = () => {
  const currentLocale = getCurrentLocale()
  return (
    <Container>
      {languages.map(({shortCode, locale}) => (
        <LanguageLink
          key={shortCode}
          active={locale === currentLocale}
          onClick={async () => {
            await storage.setItem('locale', locale)
            window.location.reload()
          }}
        >
          {shortCode}
        </LanguageLink>
      ))}
    </Container>
  )
}

export default LanguageSwitch
